export const STATUS_CONFIG = {
  frio: { label: 'Frío', color: '#64748b', bg: 'rgba(100,116,139,0.15)' },
  contactado: { label: 'Contactado', color: '#2E7DE2', bg: 'rgba(46,125,226,0.15)' },
  en_conversacion: { label: 'En conversación', color: '#eab308', bg: 'rgba(234,179,8,0.15)' },
  derivado_asesor: { label: 'Derivado a asesor', color: '#0ea5e9', bg: 'rgba(14,165,233,0.15)' },
  llamada_agendada: { label: 'Llamada agendada', color: '#f97316', bg: 'rgba(249,115,22,0.15)' },
  propuesta_enviada: { label: 'Propuesta enviada', color: '#a855f7', bg: 'rgba(168,85,247,0.15)' },
  ganado: { label: 'Ganado', color: '#22c55e', bg: 'rgba(34,197,94,0.15)' },
  perdido: { label: 'Perdido', color: '#ef4444', bg: 'rgba(239,68,68,0.15)' },
  no_responde: { label: 'No responde', color: '#475569', bg: 'rgba(71,85,105,0.15)' }
};

export const QUALIFICATION_CONFIG = {
  frio: { label: 'Frío', color: '#64748b', icon: '❄️' },
  tibio: { label: 'Tibio', color: '#eab308', icon: '🌤️' },
  caliente: { label: 'Caliente', color: '#ef4444', icon: '🔥' }
};

export const SOURCE_CONFIG = {
  research: { label: 'Research', color: '#2E7DE2', bg: 'rgba(46,125,226,0.15)' },
  web_form: { label: 'Formulario Web', color: '#22c55e', bg: 'rgba(34,197,94,0.15)' },
  csv: { label: 'CSV', color: '#f97316', bg: 'rgba(249,115,22,0.15)' },
  manual: { label: 'Manual', color: '#a855f7', bg: 'rgba(168,85,247,0.15)' },
  referido: { label: 'Referido', color: '#eab308', bg: 'rgba(234,179,8,0.15)' },
  llamada: { label: 'Llamada', color: '#06b6d4', bg: 'rgba(6,182,212,0.15)' },
  evento: { label: 'Evento', color: '#ec4899', bg: 'rgba(236,72,153,0.15)' }
};

export const STATUS_ORDER = ['frio','contactado','en_conversacion','derivado_asesor','llamada_agendada','propuesta_enviada','ganado','perdido','no_responde'];

export function formatDate(dateStr) {
  if (!dateStr) return '—';
  return new Date(dateStr).toLocaleDateString('es-AR', { day:'2-digit', month:'short', year:'numeric', hour:'2-digit', minute:'2-digit' });
}

export function formatDateShort(dateStr) {
  if (!dateStr) return '—';
  return new Date(dateStr).toLocaleDateString('es-AR', { day:'2-digit', month:'short' });
}

export function formatNumber(n) {
  if (n === null || n === undefined) return '—';
  return Number(n).toLocaleString('es-AR');
}

export function formatMoney(n) {
  if (n === null || n === undefined) return '—';
  return '$' + Number(n).toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export function buildWhatsAppUrl(phone, message, countryCode = '54') {
  let clean = phone.replace(/[^0-9+]/g, '');
  if (!clean.startsWith('+') && !clean.startsWith(countryCode)) clean = countryCode + clean;
  clean = clean.replace('+', '');
  return `https://wa.me/${clean}?text=${encodeURIComponent(message)}`;
}

export function applyTemplate(template, lead) {
  return template
    .replace(/\{\{nombre_negocio\}\}/g, lead.business_name || '')
    .replace(/\{\{rubro\}\}/g, lead.category || '')
    .replace(/\{\{sector\}\}/g, lead.category || '')
    .replace(/\{\{ubicacion\}\}/g, lead.city || lead.address || '')
    .replace(/\{\{telefono\}\}/g, lead.phone || '')
    .replace(/\{\{email\}\}/g, lead.email || '')
    .replace(/\{\{web\}\}/g, lead.website || '')
    .replace(/\{\{servicio\}\}/g, lead.service_interest || '');
}

/* Personalizaciones por cliente.

   Titila no tiene tráfico verdaderamente directo: lo que entra sin campaña
   viene de Bing, que se pauta por afuera de la plataforma. Decirle "Directo"
   escondía de dónde venían esos leads.

   Se resuelve acá, en la etiqueta, y no cambiando el dato: la fuente real del
   lead sigue siendo la que es, y si mañana Titila suma tráfico directo de
   verdad, se saca esta línea y nada más. */
const ETIQUETAS_POR_CLIENTE = {
  titila: { Directo: 'Bing' },
};

const subdominioActual = () =>
  (typeof window !== 'undefined' ? String(window.location.hostname).split('.')[0] : '');

const personalizar = (etiqueta) =>
  (ETIQUETAS_POR_CLIENTE[subdominioActual()] || {})[etiqueta] || etiqueta;

export function getSourceLabel(lead) {
  if (lead.gclid || (lead.utm_source && lead.utm_source.toLowerCase() === 'google')) return 'Google Ads';
  if (lead.fbclid || (lead.utm_source && ['facebook','instagram','meta'].includes(lead.utm_source.toLowerCase()))) return 'Meta Ads';
  if (lead.source === 'web_form' && !lead.utm_source) return personalizar('Directo');
  if (lead.source === 'research') return 'Research';
  return personalizar(SOURCE_CONFIG[lead.source]?.label || lead.utm_source || lead.source || '—');
}

// Abre la conversación en WhatsApp Web (usa el número logueado en el navegador)
export function buildWhatsAppWebUrl(phone, message, countryCode = '54') {
  let clean = String(phone || '').replace(/[^0-9+]/g, '');
  if (!clean.startsWith('+') && !clean.startsWith(countryCode)) clean = countryCode + clean;
  clean = clean.replace('+', '');
  return `https://web.whatsapp.com/send?phone=${clean}&text=${encodeURIComponent(message)}`;
}
